import React, { FC } from 'react'

import { IconPriceTagProps } from './IconPriceTag.types'
import * as Styled from './styles/IconPriceTag.style'

import { nonThemeableRules } from '../../ruleSet'

const IconPriceTag: FC<IconPriceTagProps> = ({
  size = nonThemeableRules.defaultSize as number as IconPriceTagProps['size'],
  isResponsive = false,
}: IconPriceTagProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M38.712 24.345V11.328a2.088 2.088 0 0 0-2.09-2.093H23.59a2.093 2.093 0 0 0-1.48.613l-15.988 16a4.18 4.18 0 0 0 0 5.915L16.19 41.83a4.18 4.18 0 0 0 5.912 0l16-16a2.09 2.09 0 0 0 .61-1.485Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M31.49 19.623a3.072 3.072 0 1 0 0-6.145 3.072 3.072 0 0 0 0 6.145Z'
          stroke='#0D0D0D'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path d='M31.49 16.55 42.905 5.137' stroke='#E60000' strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconPriceTag
